import React from "react";
import { Input, Form } from "antd";

// Componente de celda editable
const EditableCell = ({ editing, dataIndex, title, children, ...restProps }) => {
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item name={dataIndex} style={{ margin: 0 }} rules={[{ required: true, message: `Ingrese ${title}` }]}>
                    <Input />
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

export default EditableCell;